import Spline from "@splinetool/react-spline";

function Scene({ onLoad, isLoading }) {
  console.log("Scene component rendered");
  console.log("isLoading:", isLoading);

  return (
    <div className="w-full h-full mt-[-18%] sm:mt-0 flex justify-center items-center">
      {isLoading && (
        <div className="absolute top-0 left-0 right-0 sm:right-80 bottom-0 flex justify-center sm:justify-end items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-100"></div>
        </div>
      )}
      <Spline
        onLoad={onLoad}
        scene="https://prod.spline.design/y7wv9PJUukdT2OvG/scene.splinecode"
      />
    </div>
  );
}

export default Scene;
